import React, {useState, useEffect, useRef} from "react";
import {Link} from 'react-scroll';
import Logo from '../../../assets/images/logo_images/logo.svg';
// import MenuIcon from '../../../assets/images/navigation/menu.svg';
// import instaIcon from '../../../assets/icons/instagram.png';
import linkedinIcon from '../../../assets/icons/linkedin.png';
import emailIcon from '../../../assets/icons/email.png';
import verticalLine from '../../../assets/icons/verticalLine.png';
import phoneIcon from '../../../assets/icons/phone.png';
import CustomDropdown from "../../../components/Language";
import {useTranslation} from "react-i18next";
import './style.scss';
import Fb from "../../../assets/icons/fb.png";

const HorizontalNav = () => {
    const {t} = useTranslation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        if (isMenuOpen) {
            document.body.classList.add('menu-open');
        } else {
            document.body.classList.remove('menu-open');
        }

        if (isMenuOpen) {
            document.addEventListener('click', handleClickOutside);
        } else {
            document.removeEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.body.classList.remove('menu-open');
        };
    }, [isMenuOpen]);

    return (<>
            <header className='header'>
                <div className="container" ref={menuRef}>
                    <div className='top-header'>
                        <div className="navbar-translate">
                            <div className={'logo-main'}>
                                <Link to='home' spy={true} smooth={true} offset={-150} duration={500}
                                      activeClass="active">
                                    <img src={Logo} alt='logo' className='main-logo'/>
                                </Link>
                            </div>
                            <div className="navbar-toggle" onClick={toggleMenu}>
                                <span className="navbar-toggler-bar top-bar"></span>
                                <span className="navbar-toggler-bar middle-bar"></span>
                                <span className="navbar-toggler-bar bottom-bar"></span>
                            </div>
                        </div>
                        <div className={`container-header`}>
                            <ul className={'contact-container-list'}>
                                <li>
                                    <img src={emailIcon} width={20} height={16} alt={'email-icon'}/>
                                    <p>jobs@labourhomeindia.com</p>
                                </li>
                                <li>
                                    <img src={verticalLine} width={1} height={58} alt={'line-image'}/>
                                </li>
                                <li>
                                    <img src={phoneIcon} width={18} height={18} alt={'phone-icon'}/>
                                    <p>Help Line No +91 9218067167</p>
                                </li>
                            </ul>

                            <ul className={'social-icon-list'}>
                                <li><a href='https://www.facebook.com/LHYUG/'
                                       target='blank'><img src={Fb} alt={'fb'}/></a></li>
                                {/*<li>*/}
                                {/*    <img src={instaIcon} alt={'insta-icon'}/>*/}
                                {/*</li>*/}
                                <li>
                                    <a href="https://www.linkedin.com/company/linkedin.com-lhyug/" target="blank"><img
                                        src={linkedinIcon} alt={'linkedin-icon'}/></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={`bottom-header ${isMenuOpen ? 'open' : ''}`}>
                        <div className="nav-container">
                            <nav>
                                <ul className="nav-menu text-container">
                                    <li>
                                        <Link to='home' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.home')}</Link>
                                    </li>
                                    {/*<Link activeClass="active" className="nav-item">*/}
                                    {/*    /!*<Dropdown*!/*/}
                                    {/*    /!*    menu={{items: categories}}*!/*/}
                                    {/*    /!*>*!/*/}
                                    {/*    /!*    <Link onClick={(e) => e.preventDefault()}>*!/*/}
                                    {/*    /!*        <Space>*!/*/}
                                    {/*    /!*            Categories*!/*/}
                                    {/*    /!*            <DownOutlined size={2}/>*!/*/}
                                    {/*    /!*        </Space>*!/*/}
                                    {/*    /!*    </Link>*!/*/}
                                    {/*    /!*</Dropdown>*!/*/}
                                    {/*</Link>*/}
                                    <li>
                                        <Link to='verticals' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.verticals')}</Link>
                                    </li>

                                    <li>
                                        <Link to='about' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.about')}</Link>
                                    </li>

                                    <li>
                                        <Link to='business' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.business')}</Link>
                                    </li>
                                    <li>
                                        <Link to='subCategory' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.subCategories')}</Link>
                                    </li>
                                    {/*<Link to='feature' spy={true} smooth={true} offset={-150} duration={500} activeClass="active"*/}
                                    {/*      className="nav-item">VERTICALS</Link>*/}
                                    {/*<li>*/}
                                    {/*    <Link to='testimonials' spy={true} smooth={true} offset={-150} duration={500}*/}
                                    {/*          activeClass="active"*/}
                                    {/*          className="nav-item">{t('navigationOptions.testimonials')}</Link>*/}
                                    {/*</li>*/}
                                    <li>
                                        <Link to='contact' spy={true} smooth={true} offset={-150} duration={500}
                                              activeClass="active"
                                              className="nav-item">{t('navigationOptions.contact')}</Link>
                                    </li>
                                </ul>

                                {/*<LanguageSelector />*/}
                                <CustomDropdown/>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>

    )
}

export default HorizontalNav;
